import 'bootstrap';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'htmx.org';
import './scss/styles.scss';
import './sort-table';
import base from './base';

function frontendModule(element) {
  if ('name' in element.dataset) {
    import(
      /* webpackChunkName: "[request]" */
      `./${element.dataset.name}`
    ).then((module) => {
      module.default();
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  base();
  document.querySelectorAll(
    '.frontend-module',
  ).forEach((element) => {
    frontendModule(element);
  });
});

document.addEventListener('htmx:load', (event) => {
  // Re-initialize module on htmx load
  if (event.target.classList.contains('frontend-module')) {
    frontendModule(event.target);
  }
});
